import { unstable_createMuiStrictModeTheme } from '@material-ui/core';

import { constants, rem, Styles, theme } from '@/styles';

export const styles: Styles = {
  '.step': {
    marginTop: constants.offset.xlarge,
    marginBottom: constants.offset.large,
    color: theme.textSecondary,
  },

  '.title': {
    marginTop: constants.offset.xlarge,
    marginBottom: constants.offset.large,
    whiteSpace: 'pre-line',
    fontSize: rem(constants.fontSize.h1),
    fontWeight: 400,
    color: theme.textPrimary,
  },

  '.description': {
    marginTop: constants.offset.xlarge,
    marginBottom: constants.offset.large,
    whiteSpace: 'pre-line',
    lineHeight: 1.2,
    color: theme.textPrimary,
  },

  '.tooltip': {
    marginLeft: constants.offset.xsmall,
  },

  '.mobile-app-buttons': {
    paddingTop: constants.offset.small,
  },
};

export const tooltipStyle = unstable_createMuiStrictModeTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        backgroundColor: theme.textPrimary,
        borderRadius: 0,
        padding: constants.offset.large,
        fontSize: rem(constants.fontSize.medium),
      },
      arrow: {
        color: theme.textPrimary,
      },
    },
  },
});

export const tooltipContentStyles: Styles = {
  width: 207,
  height: 180,
};
